
/**
 * @module ol/layer
 */

export {default as Group} from './layer/Group.js';
export {default as Heatmap} from './layer/Heatmap.js';
export {default as Image} from './layer/Image.js';
export {default as Layer} from './layer/Layer.js';
export {default as Tile} from './layer/Tile.js';
export {default as Vector} from './layer/Vector.js';
export {default as VectorTile} from './layer/VectorTile.js';

//# sourceMappingURL=layer.js.map


//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/~/ol/layer.js
// module id = ../../../../ol/layer.js
// module chunks = 3